import React, {PureComponent} from 'react';
import PropTypes from 'prop-types';

import ScrollHandler from '../ScrollHandler/ScrollHandler';

class Waypoint extends PureComponent {
    static propTypes = {
        /** String or Number to pass as a parameter to onEnter and onLeave */
        label: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
        /** Function to call when the component is in View. */
        onEnter: PropTypes.func,
        /** Function to call when the component is no longer in View. */
        onLeave: PropTypes.func,
        /**
         * Override to directly change the IntersectionObserver's `rootMargin` property. Useful if you need to adjust each side's threshold values.
         * For example, if you have an absolutely positioned element at the top of the screen (like the PDP quicklinks),
         * you might want to consider something as having left the viewport before it actually does.
         * To achieve this, you can define something like: `rootMargin: -50px 0 0 0`.
         * Read more at https://developer.mozilla.org/en-US/docs/Web/API/Intersection_Observer_API
         */
        rootMargin: PropTypes.string
    };

    static defaultProps = {
        label: '',
        onEnter: () => {},
        onLeave: () => {}
    };

    constructor(props) {
        super(props);
        /* Don't use state so child won't re-render every time we update the visible state */
        this.isVisible = false;
    }

    handleLazyLoad = (inView) => {
        const {label, onEnter, onLeave} = this.props;

        if (inView && !this.isVisible) {
            this.isVisible = true;
            onEnter(label);
        } else if (!inView && this.isVisible) {
            this.isVisible = false;
            onLeave(label);
        }
    };

    render() {
        const {children, rootMargin} = this.props;
        return (
            <ScrollHandler
                onLazyLoad={this.handleLazyLoad}
                rootMargin={rootMargin}
            >
                {children}
            </ScrollHandler>
        );
    }
}

export default Waypoint;
